import {
    LIST_NOTIFICATIONS,
    LIST_NOTIFICATIONS_SUCCESS,
    LIST_NOTIFICATIONS_ERROR,
    ADD_NOTIFICATIONS,
    SAVE_NOTIFICATIONS,
    SAVE_NOTIFICATIONS_SUCCESS,
    SAVE_NOTIFICATIONS_ERROR,
    DELETE_NOTIFICATIONS,
    DELETE_NOTIFICATIONS_SUCCESS,
    DELETE_NOTIFICATIONS_ERROR,
    EDIT_NOTIFICATIONS,
    UPDATE_NOTIFICATIONS,
    UPDATE_NOTIFICATIONS_SUCCESS,
    UPDATE_NOTIFICATIONS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import notificationsData from '../data/notifications';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'notificacion';

//LISTAR NOTIFICATIONS
export function listNotificationsAction(audience) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listNotifications() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}/audiencia=${audience.id}?sort=fecha:desc`);
            //Obtengo los datos
            const notifications = response.data;
            //const notifications = notificationsData;
            //Llamo al dispatch
            dispatch( listNotificationsSuccess(notifications) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listNotificationsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listNotifications = () => ({
    type: LIST_NOTIFICATIONS,
    payload: true
});

const listNotificationsSuccess = notifications => ({
    type: LIST_NOTIFICATIONS_SUCCESS,
    payload: notifications
});

const listNotificationsError = error => ({
    type: LIST_NOTIFICATIONS_ERROR,
    payload: error
});

//ADD NOTIFICATION
export function addNotificationsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addNotifications(false) );
        //Abro el formulario
        showForm();
    }
}

const addNotifications = isEdit => ({
    type: ADD_NOTIFICATIONS,
    payload: isEdit
});

//SAVE NOTIFICATION
export function saveNotificationsAction(notification, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveNotifications() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.post(`/${controller}`, notification);
            const response = await clienteAxios.post(`/${controller}/create-send`, notification);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveNotificationsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveNotificationsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveNotifications = () => ({
    type: SAVE_NOTIFICATIONS,
    payload: true
});


const saveNotificationsSuccess = notification => ({
    type: SAVE_NOTIFICATIONS_SUCCESS,
    payload: notification
});

const saveNotificationsError = error => ({
    type: SAVE_NOTIFICATIONS_ERROR,
    payload: error
});

//EDIT NOTIFICATION
export function editNotificationsAction(notification, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editNotifications(notification) );
        //Abro el formulario
        showForm();
    }
}

const editNotifications = notification => ({
    type: EDIT_NOTIFICATIONS,
    payload: notification
});

//UPDATE NOTIFICATION
export function updateNotificationsAction(notification) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateNotifications() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/realizado/${notification.id}/true`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateNotificationsSuccess(notification) );
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateNotificationsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateNotifications = () => ({
    type: UPDATE_NOTIFICATIONS,
    payload: true
});

const updateNotificationsSuccess = notification => ({
    type: UPDATE_NOTIFICATIONS_SUCCESS,
    payload: notification
});

const updateNotificationsError = error => ({
    type: UPDATE_NOTIFICATIONS_ERROR,
    payload: error
});

//DELETE NOTIFICATION
export function deleteNotificationsAction(notification) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteNotifications() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.delete(`/${controller}/${notification.id}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteNotificationsSuccess(notification.id) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteNotificationsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteNotifications = () => ({
    type: DELETE_NOTIFICATIONS,
    payload: true
});

const deleteNotificationsSuccess = notification => ({
    type: DELETE_NOTIFICATIONS_SUCCESS,
    payload: notification
});

const deleteNotificationsError = error => ({
    type: DELETE_NOTIFICATIONS_ERROR,
    payload: error
});